import { render, staticRenderFns } from "./ActividadesDetalleGrid.vue?vue&type=template&id=67ea9113&scoped=true&"
import script from "./ActividadesDetalleGrid.vue?vue&type=script&lang=ts&"
export * from "./ActividadesDetalleGrid.vue?vue&type=script&lang=ts&"
import style0 from "./ActividadesDetalleGrid.vue?vue&type=style&index=0&id=67ea9113&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ea9113",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('67ea9113', component.options)
    } else {
      api.reload('67ea9113', component.options)
    }
    module.hot.accept("./ActividadesDetalleGrid.vue?vue&type=template&id=67ea9113&scoped=true&", function () {
      api.rerender('67ea9113', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Inicio/DetalleVehiculo/ActividadesDetalleGrid.vue"
export default component.exports